import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { Store } from '../../../../../components/actionable-filter-pill/connected/shipping/store';
import { STORE } from '../../../../../filters/constants';
import messages from './messages';

export default {
  id: STORE,
  displayName: <FormattedMessage {...messages.store} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'StoreGuid',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  allowsMultipleSelection: true,
  shouldHideActionButtons: true,
  actionableFilterPill: Store,
};
